import { Heading, Panel, P, Box, Gap } from '@salecycle/ui-component-library';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

interface Props {
  grey?: boolean;
}

const TransformationArea = styled.div<Props>`
  padding: 30px 60px;
  background-color: #cef2db;
  border-radius: 8px;
  min-width: 300px;
  text-align: center;
  margin: 10px;
  margin-left: 0;
  ${props =>
    props.grey &&
    css`
      background-color: #f5f7fa;
    `}
`;

export const FileExportTransformPreview = ({ compressFile, timestampFormat, timestampRemoval }) => {
  const { t } = useTranslation('fileExport');

  const originalFilename = 'report_2021-07-09T1700_xSFdhj.csv';
  const transformedFilename = `${
    timestampFormat
      ? originalFilename.replace('2021-07-09T1700', '09-07-2021-17:00')
      : timestampRemoval
      ? originalFilename.replace('2021-07-09T1700', '').replace('__', '_')
      : originalFilename
  }${compressFile ? '.zip' : ''}`;

  return (
    <>
      <Panel variation="clean" padding={0}>
        <Heading variation="h3">{t('config.create.preview.heading')}</Heading>
        <Box>
          <Box stackItems={true}>
            <P>{t('config.create.preview.current')}</P>
            <TransformationArea grey>{originalFilename}</TransformationArea>
          </Box>
          <Gap right={20} />
          <Box stackItems={true}>
            <P>{t('config.create.preview.new')}</P>
            <TransformationArea>{transformedFilename}</TransformationArea>
          </Box>
        </Box>
      </Panel>
    </>
  );
};
export default FileExportTransformPreview;
